import { render, staticRenderFns } from "./diversity.html?vue&type=template&id=1255465c&scoped=true&"
import script from "./diversity.vue?vue&type=script&lang=js&"
export * from "./diversity.vue?vue&type=script&lang=js&"
import style0 from "./diversity.scss?vue&type=style&index=0&id=1255465c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255465c",
  null
  
)

export default component.exports